import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import getYangsDetail from './getYangsDetail';
export default {
  getList,
  add,
  del,
  edit,
  getYangsDetail
};


// WEBPACK FOOTER //
// ./src/api/yangs/index.ts